import moment from 'moment';

import { IsEmpty } from '../../common/checks';

export const VULGARITY_CHECK_COOLDOWN_MINUTES = 5;

export const isVulgarityCheckOnCooldown = (lastCheckedAt) => {
  if (IsEmpty(lastCheckedAt)) return false;

  const nextCheckAt = moment(lastCheckedAt).add(VULGARITY_CHECK_COOLDOWN_MINUTES, 'minutes');
  return moment().isSameOrBefore(nextCheckAt);
};
